import React from 'react';
import lodashIsFunction from 'lodash/isFunction';
import lodashOmit from 'lodash/omit';
import InfoCard from 'Components/common/InfoCard/InfoCard';
import PropTypes from 'prop-types';
import {showDirectionsToEventLocation} from 'Utils/data/kioskDataUtils';
import {prependDigitalAssetsUrl} from 'Utils/prependDigitalAssetsUrl';

const EventCard = ({event, isClickable = true, selectEvent, setJourneyStop}) => {
    const showEvent = () => {
        selectEvent(event);
        if (showDirectionsToEventLocation(event) && event.feature) {
            const cleanFeature = lodashOmit(event.feature, 'icon');
            setJourneyStop({index: 1, feature: cleanFeature, zoomToResult: true});
        }
    };
    const imageUrl = event?.landscapeImageUrl?.includes('https')
        ? event.landscapeImageUrl
        : prependDigitalAssetsUrl(event.landscapeImageUrl, '_md');
    return (
        <InfoCard
            backgroundColor={`#${event.backgroundColor}`}
            bottomText={event.feature?.properties.displayText}
            className="event-container"
            imageUrl={imageUrl}
            key={event.id}
            onClick={() => (isClickable ? showEvent() : '')}
            size={!isClickable ? 'small' : 'regular'}
            textColour={`#${event.foregroundColor}`}
            title={event.name}
            topText={event.hideDateTime ? '' : event.displayTime}
            topTextColour={`#${event.foregroundColor}`}
        />
    );
};

const requiredIfItIsClickablePropType = (props, propName) => {
    if (props.isClickable && !lodashIsFunction(props[propName])) {
        return new TypeError(`${propName} is not a function`);
    }
    return undefined;
};

EventCard.propTypes = {
    event: PropTypes.object,
    isClickable: PropTypes.bool,
    selectEvent: requiredIfItIsClickablePropType,
    setJourneyStop: requiredIfItIsClickablePropType,
};

export default EventCard;
